const AndroidIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0605 12.706L11.6689 10.291L3.67718 18.4068C3.77349 18.3775 3.8757 18.3331 3.98484 18.2726C4.06659 18.2275 4.26546 18.1178 4.55775 17.9566L4.57516 17.947C6.22002 17.0398 10.7363 14.549 14.0605 12.706Z"
        fill="white"
      />
      <path
        d="M14.5148 12.4541C14.8225 12.2835 15.1173 12.1198 15.3958 11.9651C15.5932 11.8555 15.7825 11.7504 15.9623 11.6506L15.9632 11.6501C17.0803 11.0303 17.8332 10.6125 17.9235 10.5672C18.3408 10.3431 18.7719 9.75025 17.9235 9.28977C17.6608 9.15091 16.2935 8.39384 14.5128 7.40295L12.0198 9.93471L14.5148 12.4541Z"
        fill="white"
      />
      <path
        d="M14.0504 7.15998C12.573 6.34641 4.51827 1.91099 3.9847 1.62448C3.88333 1.56364 3.77535 1.52271 3.66675 1.5L11.6679 9.57941L14.0504 7.15998Z"
        fill="white"
      />
      <path
        d="M3.0551 1.59294L11.3171 9.93571L3.02425 18.3573C2.78976 18.1977 2.66699 17.864 2.66699 17.4426L2.66699 2.49271C2.66699 2.0267 2.82972 1.73995 3.0551 1.59294Z"
        fill="white"
      />
    </svg>
  );
};

export default AndroidIcon;
